const bossOptions = [
  {
    name: 'Duju',
    id: 'boss1',
  },
  {
    name: 'Bliffin',
    id: 'boss2',
  },
  {
    name: 'Mashamo',
    id: 'boss3',
  },
  {
    name: 'Rackos',
    id: 'boss4',
  },
  {
    name: 'Goub',
    id: 'boss5',
  },
  {
    name: 'Nipish',
    id: 'boss6',
  },
  {
    name: 'Damacha',
    id: 'boss7',
  },
  {
    name: 'Kandrallia',
    id: 'boss8',
  },
  {
    name: 'Ixparph',
    id: 'boss9',
  },
];

const bossById = bossOptions.reduce((acc, curr) => {
  acc[curr.id] = curr.name;
  return acc;
}, {});

module.exports = { bossOptions, bossById };



// WEBPACK FOOTER //
// ./src/lib/boss.js